import { Text } from '@dealstack/frontend/shared/components/fundament/Text/Text';
import { Tooltip } from '@dealstack/frontend/shared/components/Tooltip/Tooltip';
import {
	TEST_ELEMENT_IDS,
	UIElementIdentifier,
} from '@dealstack/frontend/shared/helper/UIElementIdentifier/UIElementIdentifier';
import { memo } from 'react';
import styled from 'styled-components';
import type { IGroupWrapperProps } from './GroupWrapper.types';

const GroupWrapper = ({
	className,
	children,
	tooltip,
	label,
	hint,
	errors,
}: IGroupWrapperProps) => {
	return (
		<div className={className}>
			{label ? (
				<GroupHeaderWrapper>
					<LabelText colorFaded bold uppercase variant="overline">
						{label}
					</LabelText>
					{tooltip ? <Tooltip tooltip={tooltip} /> : null}
				</GroupHeaderWrapper>
			) : null}

			<ContentWrapper>{children}</ContentWrapper>
			{hint && !errors ? <HintText variant="p-sm">{hint}</HintText> : null}
			<UIElementIdentifier identifier={TEST_ELEMENT_IDS.GROUP_WRAPPER_ERROR_TEXT}>
				{errors?.message ? (
					<ErrorText variant="p-sm">{errors?.message?.toString()}</ErrorText>
				) : null}
			</UIElementIdentifier>
		</div>
	);
};

export const GroupHeaderWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-start;
`;
const LabelText = styled(Text)``;
const ErrorText = styled(Text)`
	color: ${({ theme }) => theme.v2.color.error[800]};
`;
const HintText = styled(Text)`
	color: ${({ theme }) => theme.v2.color.neutral[700]};
`;
export const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
`;

const Memoized = memo(GroupWrapper);
const Styled = styled(Memoized)`
	display: flex;
	flex-direction: column;

	${GroupHeaderWrapper} {
		margin-bottom: 0.5rem;
		max-height: 1rem;
	}
	${ErrorText}, ${HintText} {
		margin-top: 0.25rem;
	}

	.__react_component_tooltip {
		max-width: 20rem;
		line-height: 1.3;
		font-family: 'Inter';
	}
`;

export { Styled as GroupWrapper };
